"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (application) => `
fragment PhotoMedia on PhotoMedia {
  mediaId
  caption
  createdAt {
    iso8601
  }
  sizes {
    large {
        size {
        width
        height
      }
      url
      authRequired
    }
    medium {
        size {
        width
        height
      }
      url
      authRequired
    }
    thumbnail {
      size {
        width
        height
      }
      url
      authRequired
    }
  }
}

mutation sendChatMessage($receiver: Int, $text: String, $attachmentMediaId: ID, $type: String) {
  ${application == "PBP"
    ? "sendChatMessage"
    : "sendChatMessage: sendPmpChatMessage"}(receiver: $receiver, text: $text, attachmentMediaId: $attachmentMediaId, type: $type) {
                            chatMessage {
                                id
                                attachment {
                                    __typename
                                    ...PhotoMedia
                                }
                            }
                        }
                    }   
                 `;
//# sourceMappingURL=sendChatMessageWithAttachmentFactory.js.map